// extracted by mini-css-extract-plugin
export default {"workflowsInstanceTable":"workflowsInstanceTable-DcYVc","table":"table-Vg0iB","icon":"icon-OCMbI","culturePlate":"culturePlate-WF2Ei","bigMessage":"bigMessage-SNnYA"};